import { useLang } from "@/i18n";
import { UserCheck, Banknote, TrendingUp } from "lucide-react";

export default function HowItWorks() {
  const { t } = useLang();
  const steps = [
    { icon: UserCheck, title: t("how.step1t"), desc: t("how.step1d") },
    { icon: Banknote, title: t("how.step2t"), desc: t("how.step2d") },
    { icon: TrendingUp, title: t("how.step3t"), desc: t("how.step3d") },
  ];
  return (
    <section className="relative py-24 bg-[#F6F9FC]" data-testid="how-section">
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#635BFF]">{t("how.eyebrow")}</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0A2540] mt-3 max-w-2xl">
          {t("how.title")}
        </h2>
        <div className="grid md:grid-cols-3 gap-6 mt-12 relative">
          <div className="hidden md:block absolute top-10 left-[16%] right-[16%] border-t border-dashed border-[#635BFF]/30" />
          {steps.map((s, i) => (
            <div
              key={s.title}
              data-testid={`how-step-${i + 1}`}
              className="relative bg-white border border-[#E6EBF1] rounded-2xl p-8 hover:-translate-y-1 hover:border-[#635BFF]/50 transition-all duration-300 hover:shadow-[0_10px_30px_rgba(99,91,255,0.12)]"
            >
              <div className="w-12 h-12 rounded-2xl bg-[#635BFF]/10 border border-[#635BFF]/20 flex items-center justify-center">
                <s.icon size={20} className="text-[#635BFF]" />
              </div>
              <h3 className="font-display text-lg font-semibold text-[#0A2540] mt-5">{s.title}</h3>
              <p className="text-sm text-[#425466] mt-2 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
